// eslint-disable-next-line import/prefer-default-export
export const PRIVACY = 'info/privacy-policy';
